import { render, staticRenderFns } from "./characteristics.vue?vue&type=template&id=0cacce35"
import script from "./characteristics.vue?vue&type=script&lang=js"
export * from "./characteristics.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports